
import { obtenerOrdenesDePago } from "../../services/services";
import useFetch from "../../hooks/useFetch";
import { messages } from "./ordenes-pago.messages";
import useProveedor from "../../hooks/useProveedor";
import OrdenesDePagoTable from "../ordenes-table/ordenes-table";
import "./ordenes-pago.styles.css";

const OrdenesDePago = () => {
    const { cuit } = useProveedor();

    const request = {
        codOrdenPago: null,
        fechaPago: null,
        nroOrdenPago: null,
        nroInternoOrdenPago: null,
        cuit: cuit,
        ejercicio: null,
        lote: null,
    };

    const { loading: loadingData, data } = useFetch(
        obtenerOrdenesDePago,
        request,
        [cuit]
    );

    const { loading: loadingMessage, noResults, results } = messages;

	const infoMessage = noResults(cuit);
	const successMessage = results(cuit, data?.length);

    const spinning = !data || loadingData;

	return (
            <OrdenesDePagoTable
				loading={spinning} 
				loadingMessage={loadingMessage} 
				data={data} 
				infoMessage={infoMessage}
				successMessage={successMessage} 
			/>
	)
};

export default OrdenesDePago;
